import 'core-js';

import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { unregister } from './registerServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
unregister();
